module.exports = __webpack_public_path__ + "d015255dc6078deb20bda29bdadc79ee.svg";